import { Card, CircularProgress, Typography } from '@mui/material';
import InvoiceVersionsTable from './invoiceVersionsTable';
import { useQuery } from '@tanstack/react-query';
import { getAllClientInvoiceHistory } from 'src/helper/backend_helper';
import { useLocation, useParams } from 'react-router';
import { ArrowBack } from '@mui/icons-material';

function InvoiceVersionsData() {
  const location: any = useLocation();
  const eventId = location.state?.id;

  const { data, error, isLoading, isError }: any = useQuery(
    ['quotes', eventId],
    () => getAllClientInvoiceHistory(eventId)
  );

  return (
    <Card sx={{ width: '100%', typography: 'body1', margin: 2, p: 2 }}>
      <Typography
        variant="h4"
        gutterBottom
        pb={2}
        display="flex"
        gap={1}
        align="center"
      >
        <ArrowBack
          onClick={() => window.history.back()}
          sx={{ cursor: 'pointer' }}
        />{' '}
        Client Invoice History
      </Typography>
      {isLoading ? (
        <CircularProgress size={15} />
      ) : isError ? (
        <p>Error: {error.message}</p>
      ) : (
        <InvoiceVersionsTable Job={data?.data?.data} />
      )}
    </Card>
  );
}

export default InvoiceVersionsData;
